module.exports = __webpack_public_path__ + "static/shapes-d4761d5df8d7c738bd503fe8a021201d.png";